import React, { useEffect } from 'react'
// import { useLocation} from 'react-router-dom'

import urls from '../../../utils/constants/urls'
import LoadingSpinner from '../../elem/LoadingSpinner'

export default () => {
    useEffect(() => {
        const t = setTimeout(() => {
            // get the redirect uri from local storage
            const redirectTargetUri = localStorage.getItem('redirectTargetUri')
            if (redirectTargetUri) {
                // clear the redirect uri from local storage before redirect
                localStorage.removeItem('redirectTargetUri')
                window.location = redirectTargetUri
            } else {
                window.location = urls.home
            }
        }, 5000)
        return () => clearTimeout(t)
    }, [])
    // if (location.search.includes('access_denied')) {
    //     window.location = urls.home
    // }
    
    return <LoadingSpinner />
}
